import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import App from './App.tsx'
import './index.css'

const rootEl = document.getElementById("root")!;

const app = (
  <HelmetProvider>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </HelmetProvider>
);

// O pré-render é um snapshot de uma aplicação cliente, sem estado SSR ou
// marcadores de hidratação. React substitui o snapshot ao iniciar; o HTML
// completo continua disponível antes do JavaScript para crawlers.
createRoot(rootEl).render(app);

// Gatilho dos posts agendados: a hospedagem não tem cron, então a visita avisa o
// servidor, que publica os vencidos. Depois do load, fora do caminho do LCP.
if (!location.pathname.startsWith('/admin')) {
  window.addEventListener('load', () => {
    setTimeout(() => { try { navigator.sendBeacon('/api/agendados.php'); } catch { /* opcional */ } }, 3000);
  }, { once: true });
}
